import { AuthService } from "../../_services";
import router from "../../_router";
import Axios from "axios";
import * as Cookie from "js-cookie";

const getDefaultState = () => {
  const user = Cookie.get("user") ? JSON.parse(Cookie.get("user")) : null;
  return {
    status: {},
    info: user ? user.info : null,
    token: user ? user.token : null
  };
};

const state = getDefaultState();

//   ACTIONS
const actions = {
  async login({ dispatch, commit }, { username, password }) {
    commit("LOGIN_REQUEST", { username });

    try {
      const response = await AuthService.login({ username, password });

      commit("SET_TOKEN", response.token);
      commit("LOGIN_SUCCESS", response.user);

      // set auth header
      Axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${response.token}`;

      router.push("/dashboard");
    } catch (error) {
      commit("LOGIN_FAILURE", error);
      dispatch("alert/error", error, { root: true });
    }
  },

  async register({ dispatch, commit }, user) {
    commit("REGISTER_REQUEST", user);

    try {
      const response = await AuthService.signUp(user);

      commit("SET_TOKEN", response.token);
      commit("REGISTER_SUCCESS", response.user);

      // set auth header
      Axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${response.token}`;

      setTimeout(() => {
        // display success message after route change completes
        dispatch("alert/success", "Registration successful", { root: true });
      });

      router.push("/dashboard");
    } catch (error) {
      commit("REGISTER_FAILURE", error);
      dispatch("alert/error", error, { root: true });
    }
  },

  async forgotpassword({ dispatch, commit }, { username }) {
    commit("RESET_REQUEST");

    try {
      const response = await AuthService.forgotPassword({ username });
      commit("RESET_SUCCESS");

      dispatch("alert/success", response.message, { root: true });

      setTimeout(() => {
        router.push("/reset/password");
      }, 500);
    } catch (error) {
      commit("RESET_FAILURE");
      dispatch("alert/error", error, { root: true });
    }
  },

  async resetpassword({ dispatch, commit }, credentials) {
    commit("RESET_REQUEST");

    try {
      const response = await AuthService.resetPassword(credentials);
      commit("RESET_SUCCESS");

      dispatch("alert/success", response.message, { root: true });

      setTimeout(() => {
        router.push("/login");
      }, 1000);
    } catch (error) {
      commit("RESET_FAILURE");
      dispatch("alert/error", error, { root: true });
    }
  },

  logout({ commit }) {
    commit("LOGOUT");
    router.push("/login");
  }
};

// MUTATIONS
const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },

  LOGIN_REQUEST(state, user) {
    state.status = { loggingIn: true };
    state.info = user;
  },

  LOGIN_SUCCESS(state, user) {
    state.status = { loggedIn: true };
    state.info = user;
  },

  LOGIN_FAILURE(state) {
    state.status = {};
    state.info = null;
  },

  REGISTER_REQUEST(state) {
    state.status = { registering: true };
  },

  REGISTER_SUCCESS(state, user) {
    state.status = {};
    state.info = user;
  },

  REGISTER_FAILURE(state) {
    state.status = {};
  },

  RESET_REQUEST(state) {
    state.status = { resetting: true };
  },

  RESET_SUCCESS(state) {
    state.status = {};
  },

  RESET_FAILURE(state) {
    state.status = {};
  },

  LOGOUT(state) {
    // remove user from cookie to log user out
    Cookie.remove("user");

    // Merge rather than replace so we don't lose observers
    //-> https://github.com/vuejs/vuex/issues/1118
    Object.assign(state, getDefaultState());
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
